module.exports = __webpack_public_path__ + "img/green-arrow-down.b306d1b7.svg";